export const isPrestashop = () => {
  return !!global.prestashop
}

export function isInsecureEnvironment() {
  return window.__kjsIsInsecureEnvironment__ || !window.isSecureContext
}
